export default {
  namespaced: true,
  state: {
    tableSettings: {}
  },
  getters: {
    getSettingsFor: state => tableId => {
      if (!Object.hasOwn(state.tableSettings, tableId)) {
        return []
      }
      return state.tableSettings[tableId]
    }
  },
  mutations: {
    setTableSettings(state, tableSettings) {
      state.tableSettings = tableSettings
    }
  },
  actions: {
    storeTableSettings(context, tableSettings) {
      const tableData = {}
      tableSettings.forEach(data => {
        if (!Object.hasOwn(tableData, data.table_id)) {
          tableData[data.table_id] = []
        }
        const filters = data?.metadata?.filters
        if (filters) {
          for (const [key, value] of Object.entries(filters)) {
            if (Array.isArray(value)) {
              data.metadata.filters[key] = value.map(f => {
                if (typeof f === 'object') {
                  return JSON.stringify(f)
                }
                return f
              })
            }
          }
        }
        tableData[data.table_id].push(data)
      })
      context.commit('setTableSettings', tableData)
    }
  }
}
